import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=08f1f886&scoped=true"
import script from "./newRole.vue?vue&type=script&lang=js"
export * from "./newRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1f886",
  null
  
)

export default component.exports